export default __webpack_public_path__ + "static/media/image4mobile.620d8c74.png";